
import gql from 'graphql-tag'



const USER_INSERT =  gql`mutation ($name: name!, $address: String!, $phone: numeric!, $email: String!,
     $nationality: String!, $gender: String!, $idNumber: String!, $picture: String!, $date_of_birth: date!,
      $tokenId: String!, $toBeDelegated: Boolean!, $inPhone: String!, $isClient: Boolean!, $isBusiness: Boolean!){
                insert_user(
                    objects:[
                    {
                        name: $name,
                        address: $address,
                        phone: $phone,
                        in_phone:$inPhone,
                        old_phone: $phone,
                        email: $email,
                        nationality: $nationality,
                        gender: $gender,
                        identification_number: $idNumber,
                        picture: $picture,
                        date_of_birth: $date_of_birth,
                        token_id: $tokenId,
                        to_be_delegated: $toBeDelegated,
                        is_client: $isClient,
                        is_business: $isBusiness
                    }
                    ])
                    {   
                        affected_rows
                        returning {
                        id    
                        name
                        address
                        phone
                        email
                        nationality
                        gender
                        identification_number
                        picture
                        date_of_birth
                     }
                    }
                }`;

const DELEGATED_USER_INSERT =  gql`mutation ($userId: Int!, $delegatedUserId: Int, 
    $tokenId: String!, $delegatedUserEmail: String!, $businessId: Int!){
        
                    insert_delegated_user(
                        objects:[
                        {
                            user_id: $userId,
                            delegated_user_id: $delegatedUserId,
                            token_id: $tokenId,
                            delegated_user_email: $delegatedUserEmail,
                            business_id: $businessId

                        }
                        ])
                        {   
                            affected_rows
                            returning {

                            delegated_user_id
                            }
                        }
                    }`;


const BRAND_INSERT =  gql`mutation ($name: name!, $phone: numeric!, 
    $picture: String!, $tokenId: String!, $userId:Int!, $license: String!, $isInstructor: Boolean!){
                    insert_brand(
                        objects:[
                        {
                            name: $name,
                            phone: $phone,
                            logo: $picture,
                            token_id: $tokenId,
                            user_id:$userId,
                            license: $license,
                            is_instructor: $isInstructor

                        }
                        ])
                        {   
                            affected_rows
                            returning {
                            id    
                            name
                            phone
                            logo
                            license
                            is_instructor
                            }
                        }
                    }`;
                   

const BRAND_TO_BRAND_CATEGORY_INSERT =  gql`mutation ($brandId: Int!, $brandCategoryId: Int!, $tokenId: String!){
                    insert_brand_to_brand_category(
                        objects:[
                        {
                            brand_id: $brandId,
                            brand_category_id: $brandCategoryId,
                            token_id: $tokenId
                        }
                        ])
                        {   
                            affected_rows
                            returning {
                                brand_id  
                                brand_category_id  
                            }
                        }
                    }`;

const BUSINESS_INSERT =  gql`mutation ($name: name!, $address: String!, $phone: numeric!, $email: String!, $ownerId: Int!,
    $isPrivate: Boolean!, $picture: String!, $tokenId: String! , $latitude: String!, $longitude: String!,$locationName: name!, 
    $locationUrl: String!, $license: String!, $brandId: Int!, $country: String!, $countryCode: String!,
    $brokerId: Int!, $brokerName: String!){
    insert_business(
        objects:[
        {
            name: $name,
            location: {data: {token_id: $tokenId, address: $address, latitude: $latitude, longitude: $longitude,
            name: $locationName, url: $locationUrl, country: $country, country_code: $countryCode}},
            address: $address,
            owner_id: $ownerId,
            phone: $phone,
            token_email: $email,
            logo: $picture,
            token_id: $tokenId,
            license: $license,
            is_private: $isPrivate,
            brand_id: $brandId,
            broker_id: $brokerId,
            broker_name: $brokerName,
            user_business_points: {
                data: {
                    user_id: $ownerId,
                    brand_id: $brandId
                    }
                }
            }
        ])
        {   
            affected_rows
            returning {
            id    
            name
            address
            phone
            token_email
            logo
            license
            is_private
            location{
                id
                name
                latitude
                longitude
                address
                url
            }
        }
    }
}`;

const BUSINESS_INSERT_WITH_CITY =  gql`mutation ($name: name!, $address: String!, $phone: numeric!, $email: String!, $ownerId: Int!,
    $isPrivate: Boolean!, $picture: String!, $tokenId: String! , $latitude: String!, $longitude: String!,$locationName: name!, 
    $locationUrl: String!, $license: String!, $brandId: Int!, $country: String!, $countryCode: String!, $cityId: Int!,
    $brokerId: Int!, $brokerName: String!){
    insert_business(
        objects:[
        {
            name: $name,
            location: {data: {token_id: $tokenId, address: $address, latitude: $latitude, longitude: $longitude,
            name: $locationName, url: $locationUrl, country: $country, country_code: $countryCode, city_id: $cityId}},
            address: $address,
            owner_id: $ownerId,
            phone: $phone,
            token_email: $email,
            logo: $picture,
            token_id: $tokenId,
            license: $license,
            is_private: $isPrivate,
            brand_id: $brandId,
            broker_id: $brokerId,
            broker_name: $brokerName,
            user_business_points: {
                data: {
                    user_id: $ownerId,
                    brand_id: $brandId
                    }
                }
            }
        ])
        {   
            affected_rows
            returning {
            id    
            name
            address
            phone
            token_email
            logo
            license
            is_private
            location{
                id
                name
                latitude
                longitude
                address
                url
            }
        }
    }
}`;

const LOCATION_INSERT =  gql`mutation ($address: String!, $tokenId: String! , $latitude: String!, $longitude: String!,
    $locationName: name!, $locationUrl: String!, $businessId: Int!, $country: String!, $countryCode: String!){
    insert_location(
        objects:[

        {
            token_id: $tokenId, 
            address: $address,
            latitude: $latitude,
            longitude: $longitude,
            name: $locationName,
            url: $locationUrl,   
            country: $country,
            country_code: $countryCode,
            business_id: $businessId 
        },

        
        ])
        {   
            affected_rows
            returning {
            id
            name
            latitude
            longitude
            address
            url
            business{  
                id    
                name
                address
                phone
                token_email
                logo
                license
                is_private
            }
        }
    }
}`;

const LOCATION_INSERT_WITH_CITY =  gql`mutation ($address: String!, $tokenId: String! , $latitude: String!, $longitude: String!,
    $locationName: name!, $locationUrl: String!, $businessId: Int!, $country: String!, $countryCode: String!, $cityId: Int!){
    insert_location(
        objects:[

        {
            token_id: $tokenId, 
            address: $address,
            latitude: $latitude,
            longitude: $longitude,
            name: $locationName,
            url: $locationUrl,   
            country: $country,
            country_code: $countryCode,
            business_id: $businessId,
            city_id: $cityId 
        },

        
        ])
        {   
            affected_rows
            returning {
            id
            name
            latitude
            longitude
            address
            url
            business{  
                id    
                name
                address
                phone
                token_email
                logo
                license
                is_private
            }
        }
    }
}`;

const BUSINESS_INSERT_WITH_LOCATION =  gql`mutation ($name: name!, $address: String!, $phone: numeric!, $email: String!, $ownerId: Int!,
    $isPrivate: Boolean!, $picture: String!, $tokenId: String!, $locationId: Int!, $license: String!, $brandId: Int!){
        insert_business(
            objects:[
            {
                name: $name,
                location_id: $locationId
                address: $address,
                owner_id: $ownerId,
                phone: $phone,
                token_email: $email,
                logo: $picture,
                token_id: $tokenId,
                license: $license,
                is_private: $isPrivate,
                brand_id: $brandId,
                user_business_points: {
                    data: {
                        user_id: $ownerId,
                        brand_id: $brandId
                        }
                    }
            }
            ])
            {   
                affected_rows
                returning {
                id    
                name
                address
                phone
                token_email
                logo
                license
                is_private
                location{
                    id
                    name
                    latitude
                    longitude
                    address
                    url
            }
        }
    }
}`; 

const CLASS_INSERT =  gql`mutation ($name: name!,  $userId: Int!, $instructorId: Int!,$description: String!, $instructorName: String!,
    $image_1: String!, $image_2: String!, $image_3: String!, $image_4: String!, $level: String!, $image_5: String!,
     $image_6: String!, $image_7: String!, $image_8: String!, $points: Int!, $cash: Int!, $isOnline: Boolean!, $payCash: Boolean!, $payPoints: Boolean!, $myTimeStamp: String!,
    $locationName: name!, $address: String!, $latitude: String!, $longitude: String!, $locationUrl:String!, $country: String!,
    $tokenId: String!, $businessId: Int!){
        insert_class(
            objects:[
            {
                name: $name,
                description: $description,
                location: {data: {token_id: $tokenId, address: $address, latitude: $latitude, longitude: $longitude,
                     name: $locationName, url: $locationUrl, country: $country}},
                created_by_user: $userId,
                instructor_name: $instructorName,
                instructor_id: $instructorId,
                image_1:$image_1,
                image_2:$image_2,
                image_3:$image_3,
                image_4:$image_4,
                image_5:$image_5,
                image_6:$image_6,
                image_7:$image_7,
                image_8:$image_8,
                token_id: $tokenId,
                level: $level,
                points_cost: $points,
                cash_cost: $cash,
                is_online: $isOnline,
                pay_cash: $payCash,
                pay_points: $payPoints,
                business_id: $businessId,
                my_time_stamp: $myTimeStamp
            }
            ])
            {   
                affected_rows
                returning {
                    id
                    name
                    location_id
                    created_by_user
                    instructor_id
                    image_1
                    image_2
                    image_3
                    image_4
                    image_5
                    image_6
                    image_7
                    image_8
                    token_id
                    level
                    points_cost
                    cash_cost
                    is_online
                    business_id
            }
        }
}`; 

const   CLASS_INSERT_WITH_LOCATION =  gql`mutation ($name: name!,  $userId: Int!, $instructorId: Int!, $description: String!,$instructorName: String!,
    $image_1: String!, $image_2: String!, $image_3: String!, $image_4: String!, $level: String!, $isOnline: Boolean!, $payCash: Boolean!, $payPoints: Boolean!,
    $image_5: String!, $image_6: String!, $image_7: String!, $image_8: String!, $points: Int!, $cash: Int!, $myTimeStamp: String!,
    $tokenId: String!, $locationId: Int!, $businessId: Int!){
        insert_class(
            objects:[
            {
                name: $name,
                description: $description,
                location_id: $locationId,
                created_by_user: $userId,
                instructor_name: $instructorName,
                instructor_id: $instructorId,
                image_1:$image_1,
                image_2:$image_2,
                image_3:$image_3,
                image_4:$image_4,
                image_5:$image_5,
                image_6:$image_6,
                image_7:$image_7,
                image_8:$image_8,
                token_id: $tokenId,
                level: $level,
                points_cost: $points,
                cash_cost: $cash,
                is_online: $isOnline,
                pay_cash: $payCash,
                pay_points: $payPoints,
                business_id: $businessId,
                my_time_stamp: $myTimeStamp,
            }
            ])
            {   
                affected_rows
                returning {
                    id
                    name
                    location_id
                    created_by_user
                    instructor_id
                    image_1
                    image_2
                    image_3
                    image_4
                    image_5
                    image_6
                    image_7
                    image_8
                    token_id
                    level
                    points_cost
                    cash_cost
                    is_online
                    business_id
            }
        }
}`;    


const CLASS_CATEGORY_INSERT =  gql`mutation ($classId: Int!, $categoryId: Int!){
    insert_class_category(
        objects:[
        {
            class_id: $classId,
            category_id: $categoryId,
        }
        ])
        {   
            affected_rows
    }
}`;
   

const USER_TYPE_INSERT =  gql`mutation ($type_id: Int!, $user_id: Int!){
    insert_user_type(
        objects:[
        {
            type_id: $type_id,
            user_id: $user_id,
        }
        ])
        {   
            affected_rows
            returning {
            id    
            type_id
            user_id
        }
    }
}`;

const TYPE_INSERT =  gql`mutation ($name: String!){
    insert_type(
        objects:[
        {
            name: $name,
        }
        ])
        {   
            affected_rows
            returning { 
                name
        }
    }
}`

const SLOT_INSERT =  gql`mutation ($classId: Int!, $instructorId: Int!, $monday: Boolean!, $tuesday: Boolean!, $instructorName: name!,
     $wednesday: Boolean!, $thursday: Boolean!, $friday: Boolean!, $saturday: Boolean!, $sunday: Boolean!, $capacity: Int!,
    $startDate: date!, $endDate: date!, $startTime: time!, $endTime: time!, $points: Int!, $cash: Int!, $tokenId: String!, $link: String!
    $males: Boolean!, $females: Boolean!, $payCash: Boolean!, $payPoints: Boolean!,){
    insert_slot(
        objects:[
        {
            class_id: $classId,
            instructor_id: $instructorId,
            instructor_name: $instructorName,
            start_date: $startDate,
            end_date: $endDate,
            start_time: $startTime,
            end_time: $endTime,
            points_cost: $points,
            cash_cost: $cash,
            pay_cash: $payCash,
            pay_points: $payPoints,
            capacity: $capacity,
            token_id: $tokenId,
            monday: $monday,
            tuesday: $tuesday,
            wednesday: $wednesday,
            thursday: $thursday,
            friday: $friday,
            saturday: $saturday,
            sunday: $sunday,
            males: $males,
            females: $females,
            link: $link,
        }
        ])
        {   
            affected_rows
            returning {
                instructor{
                    id
                    name
                    user{
                        email
                    }
                }
                start_date
                end_date
                start_time
                end_time
                monday
                tuesday
                wednesday
                thursday
                friday
                saturday
                sunday
                cash_cost
                points_cost
                pay_cash
                pay_points

                class{
                    id
                    name
                }                                    
            }
        }
    }`;

const BOOKING_INSERT =  gql`mutation ($slotId: Int!, $userId: Int!, $points: Int!, $capacity: Int!){
        insert_bookings(
            objects:[
            {
                slot_id: $slotId,
                user_id: $userId,
                token_id: $tokenId,
                points: $points,
                capacity:$capacity ,

            }
            ])
            {   
                affected_rows
                returning { 
                    name
            }
        }
    }`

const ERRORS_LOGS_INSERT =  gql`mutation ($userId: Int!, $viewName: String!,
     $componentName: String!, $methodName: String!, $error: String!){
    insert_errors_logs(
        objects:[
        {
            user_id: $userId,
            view: $viewName,
            component: $componentName,
            method: $methodName,
            error_statement: $error,
        }
        ])
        {   
            affected_rows
            returning { 
                error_statement
        }
    }
}`



export default {

    user_insert: USER_INSERT,
    
    delegated_user_insert: DELEGATED_USER_INSERT,

    brand_insert: BRAND_INSERT,

    brand_to_brand_category_insert: BRAND_TO_BRAND_CATEGORY_INSERT,

    business_insert: BUSINESS_INSERT,

    business_insert_with_city: BUSINESS_INSERT_WITH_CITY,

    location_insert: LOCATION_INSERT,

    location_insert_with_city: LOCATION_INSERT_WITH_CITY,

    business_insert_with_location: BUSINESS_INSERT_WITH_LOCATION,
    
    user_type_insert: USER_TYPE_INSERT,

    type_insert :TYPE_INSERT,

    class_insert: CLASS_INSERT,

    class_insert_with_location: CLASS_INSERT_WITH_LOCATION,

    class_category_insert: CLASS_CATEGORY_INSERT,

    slot_insert: SLOT_INSERT,

    booking_insert: BOOKING_INSERT,
    
    errors_logs_insert: ERRORS_LOGS_INSERT,

}